import React, { type JSX } from "react";
import DealsTab from "../../DealsTab_Component";
import DocsTab from "../../DocsTab_Component";
import DocumentPreviewTab from "../../DocumentPreviewTab_Component";
import DealDetailsPanel from "../../DealDetailsPanel_Component";
import DealDocsPanel from "../../DealDocsPanel_Component";
import ExpertProfilePanel from "../../ExpertProfilePanel_Component";
import type { DocumentTab } from "./WorkspaceTabBar";

/** Renders the panel belonging to the currently active workspace tab. */
export default function WorkspaceTabContent({
  activeTab,
  documentTabs,
  onCloseDocument,
}: {
  activeTab: string;
  documentTabs: DocumentTab[];
  onCloseDocument: (docId: string) => void;
}): JSX.Element | null {
  switch (activeTab) {
    case "DealSummary":
      return <DealDetailsPanel />;
    case "DealDocs":
      return <DealDocsPanel />;
    case "ExpertProfile":
      return <ExpertProfilePanel />;
    case "Deals":
      return <DealsTab />;
    case "Docs":
      return <DocsTab />;
    default: {
      // Document preview tabs are named after the document, so they fall through
      // to a lookup rather than a fixed case.
      const documentTab = documentTabs.find((tab) => tab.name === activeTab);
      if (!documentTab) return null;
      return (
        <DocumentPreviewTab
          document={documentTab.document}
          onClose={() => onCloseDocument(documentTab.id)}
        />
      );
    }
  }
}
